import React, { useContext } from 'react';
import { Box } from '@mui/material';
import SmsStatusLabel from './SmsStatusLabel';
import StoreContext from '../context/StoreContext';
import SmsContext from '../context/SmsContext';
import Proptypes from 'prop-types';

const WODetails = ({rowData}) => {
  const { promisedTimeSms, globalBeback } = useContext(StoreContext);
  const { sendingSms, messageType } = useContext(SmsContext)

  return (
    <Box sx={{ margin: "15px 0px 15px 78px" }}>
      <p className='flex' style={{ margin: '0.025em 0', padding: '0', fontSize: '.8rem'}}><strong className='w-40'>WorkOrder: </strong>{rowData.WO}</p>
      {
        +promisedTimeSms !== 0 &&
        <SmsStatusLabel 
          messages={rowData.SmsData?.promisedTimeMessage} 
          type={'Promise Time'}
          isSendingSms={(sendingSms?.includes(rowData.WO) && messageType === 'promisedTimeMessage')}
        />
      }
      {
        (+promisedTimeSms !== 0 && !!rowData.SmsData?.promisedTimeMessageUpdate.length) &&
        <SmsStatusLabel 
          messages={rowData.SmsData?.promisedTimeMessageUpdate} 
          isSendingSms={(sendingSms?.includes(rowData.WO) && messageType === 'promisedTimeMessageUpdate')}
          type={'Promise Time (Updated)'}
        />
      }
      <SmsStatusLabel 
        messages={rowData.SmsData?.callStoreMessage} 
        type="Call Store" 
        isSendingSms={(sendingSms?.includes(rowData.WO) && messageType === 'callStoreMessage')}
      />
      {
        (globalBeback || rowData.IsMarshal) &&
        <SmsStatusLabel 
          messages={rowData.SmsData?.beBackMessage} 
          type="Beback" 
          isSendingSms={(sendingSms?.includes(rowData.WO) && messageType === 'beBackMessage')}
        />
      }
      <SmsStatusLabel 
        messages={rowData.SmsData?.vehicleReadyMessage} 
        type="Vehicle Ready" 
        isSendingSms={(sendingSms?.includes(rowData.WO) && messageType === 'vehicleReadyMessage')}
      />
    </Box>
  );
}

WODetails.propTypes = {
  rowData: Proptypes.object
}

export default WODetails;
